import routerOptions0 from "/builds/web-dev/front/academica/academgen/node_modules/.pnpm/nuxt@3.9.0_@parcel+watcher@2.4.1_@types+node@20.12.7_encoding@0.1.13_eslint@8.37.0_opti_9679c36f1d8e90b11d506086891f99dc/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}